import { render, staticRenderFns } from "./PilihKelasX.vue?vue&type=template&id=02692ea9&"
import script from "./PilihKelasX.vue?vue&type=script&lang=js&"
export * from "./PilihKelasX.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports